module.exports = __webpack_public_path__ + "img/B6403_CyclewayVisuals_Location_02_RZ.807b6837.jpg";